import {
  Grid,
  makeStyles,
} from "@material-ui/core";
import React, { useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import SidebarDisputes from "features/disputesRv/SidebarDisputes";
import GeneralActivitiesACCB from "../GeneralActivitiesACCB";
import useViewportFill from "../hooks/useViewportFill";

const useStyles = makeStyles((theme) => ({
  // Like the admin dashboard: from sm up the page fills the screen below the
  // header and never scrolls itself; the case list and the activity panel each
  // scroll on their own, so the header stays put. On phones (xs) the two panes
  // stack and the page scrolls normally.
  root: {
    [theme.breakpoints.up("sm")]: {
      height: "var(--accb-fill-height, 100vh)",
      overflow: "hidden",
      flexWrap: "nowrap",
    },
  },
  pane: {
    [theme.breakpoints.up("sm")]: {
      height: "100%",
      minHeight: 0,
      overflowY: "auto",
    },
  },
  sidebar: {
    padding: "2rem",
    borderRight: "1px solid #BDBDBD",
    // three extra font families on
    // this page next to the theme's Noto Sans. Normalise here rather than in
    // the shared component so the other tenants keep their own fonts.
    "& *": {
      fontFamily: `${theme.typography.fontFamily} !important`,
    },
    [theme.breakpoints.down("sm")]: {
      padding: "1rem",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "1rem",
      minHeight: 0,
      borderRight: 0,
      borderBottom: "1px solid #BDBDBD",
    },
  },
  activity: {
    padding: "2rem 4rem 2rem 2rem",
    [theme.breakpoints.down("sm")]: {
      padding: "1rem",
    },
  },
}));

export default function DisputesACCB({
  profile,
  disputesActiveClaimant,
  disputesResolvedClaimant,
  disputesActiveRespondent,
  disputesResolvedRespondent,
  disputesActiveArbitrator,
  disputesResolvedArbitrator,
  removeDisputeFromList,
}) {
  const classes = useStyles();
  const history = useHistory();

  const [activities, setActivities] = useState([]);

  const rootRef = useRef(null);
  const viewportHeight = useViewportFill(rootRef);

  return (
    <Grid
      container
      ref={rootRef}
      className={classes.root}
      // Only used from sm up (see .root); on phones the stacked panes keep
      // their natural height.
      style={{ "--accb-fill-height": viewportHeight }}
    >
      {/* sidebar */}
      <Grid
        item
        md={4}
        sm={5}
        xs={12}
        className={`${classes.sidebar} ${classes.pane}`}
        style={{ backgroundColor: "white", borderRight: "1px solid #E5E5E5" }}
      >
        <SidebarDisputes
          profile={profile}
          disputesActiveClaimant={disputesActiveClaimant}
          disputesResolvedClaimant={disputesResolvedClaimant}
          disputesActiveRespondent={disputesActiveRespondent}
          disputesResolvedRespondent={disputesResolvedRespondent}
          disputesActiveArbitrator={disputesActiveArbitrator}
          disputesResolvedArbitrator={disputesResolvedArbitrator}
          history={history}
          removeDisputeFromList={removeDisputeFromList}
          showDirectDisputeName={true}
          closedTabLabel="Disposal"
        />
      </Grid>
      {/* activity */}
      <Grid item md={8} sm={7} xs={12} className={`${classes.activity} ${classes.pane}`}>

        <GeneralActivitiesACCB
          activities={activities}
          setActivities={setActivities}
          activityTitle="Account Activity"
        />
      </Grid>
    </Grid>
  );
}
